/**
 * @generated SignedSource<<127a493f3bd30afafebdf2612f947aa4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type conditionalFormattingExperience_issueNavigator_ConditionalFormattingSidebarExperience$data = {
  readonly projectId: string | null | undefined;
  readonly " $fragmentType": "conditionalFormattingExperience_issueNavigator_ConditionalFormattingSidebarExperience";
};
export type conditionalFormattingExperience_issueNavigator_ConditionalFormattingSidebarExperience$key = {
  readonly " $data"?: conditionalFormattingExperience_issueNavigator_ConditionalFormattingSidebarExperience$data;
  readonly " $fragmentSpreads": FragmentRefs<"conditionalFormattingExperience_issueNavigator_ConditionalFormattingSidebarExperience">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "conditionalFormattingExperience_issueNavigator_ConditionalFormattingSidebarExperience",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "projectId"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "ce141e9567233fe12a9f9a4831caa142";

export default node;
